import { combineReducers } from 'redux';
import { SessionReducer, SessionSelect } from './session'
import SnapitReducer, * as SnapitSelect from './snapit_app/reducers'
import { reducer as FormReducer } from 'redux-form'
import { reducer as BurgerMenu } from 'redux-burger-menu'

//import { Map } from 'immutable'

const rootReducer = combineReducers({
  session: SessionReducer,
  snapit: SnapitReducer,
  form: FormReducer,
  burgerMenu: BurgerMenu
});

export default rootReducer;

export const currentUser = (state) => SessionSelect.currentUser(state.session);

export const getCategories = (state) => SnapitSelect.getCategories(state.snapit);

export const getItemsById = (state) => SnapitSelect.getItemsById(state.snapit);

export const getItemIds = (state) => SnapitSelect.getItemIds(state.snapit);

export const getDraftItem = (state) => SnapitSelect.getDraftItem(state.snapit);

export const getPendingItemIds = (state) => SnapitSelect.getPendingItemIds(state.snapit);

export const getPendingItems = (state) => SnapitSelect.getPendingItems(state.snapit);



// WEBPACK FOOTER //
// ./src/reducer.js